<template>
  <div v-if="deliveryOption" class="section-summary-row">
    <span>{{ title }}</span>
    <span class="body-text">
        <span class="icon" v-bind:class="deliveryOption.cssClass" ></span>
        <span>
            <b>{{ deliveryOption.name }}</b><br>
            {{ deliveryOption.description }}
        </span>
    </span>
  </div>
</template>
<script src="./home-delivery-summary.js"/>
